import { isValidLurkerEvent } from './validateLurkerEvent'

export class AndroidBridge {
  constructor() {
    this.nativeBridge = window?.ChangePasswordJsBridge
  }

  isWebView() {
    return !!this.nativeBridge?.isWebView()
  }

  onPasswordChanged(success) {
    if (!this.isWebView()) return

    try {
      this.nativeBridge?.onPasswordChanged(success)
    } catch (error) {
      console.error('[AndroidBridge] onPasswordChanged failed:', error)
    }
  }

  onPasswordChangeCancel() {
    if (!this.isWebView()) return

    try {
      this.nativeBridge?.onPasswordChangeCancel()
    } catch (error) {
      console.error('[AndroidBridge] onPasswordChangeCancel failed:', error)
    }
  }

  showMessage(type, message) {
    if (!this.isWebView()) return

    try {
      this.nativeBridge?.showMessage(type, message)
    } catch (error) {
      console.error('[AndroidBridge] showMessage failed:', error)
    }
  }

  goBack() {
    if (!this.isWebView()) return

    try {
      this.nativeBridge?.goBack()
    } catch (error) {
      console.error('[AndroidBridge] goBack failed:', error)
    }
  }

  close() {
    if (!this.isWebView()) return

    try {
      this.nativeBridge?.close()
    } catch (error) {
      console.error('[AndroidBridge] close failed:', error)
    }
  }

  sendToLurker(event) {
    if (!this.isWebView()) return

    if (!isValidLurkerEvent(event)) {
      if (process?.env?.NODE_ENV !== 'production') {
        console.warn('[AndroidBridge] Lurker event inválido:', event)
      }
      return
    }

    const { object_name, object_detail, event_type, data, params } = event

    try {
      this.nativeBridge?.sendToLurker(
        event_type,
        object_name,
        object_detail,
        JSON.stringify(params || {}),
        JSON.stringify(data || {})
      )
    } catch (error) {
      console.error('[AndroidBridge.sendToLurker] Failed to call native handler:', error)
    }
  }

  redirectTo(origin, adId, action, category) {
    if (!this.isWebView()) return

    try {
      this.nativeBridge?.redirectTo(origin, adId, action, category)
    } catch (error) {
      console.error('[AndroidBridge.redirectTo] Failed to call native handler:', error)
    }
  }
}
